function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "compose",
  d: "M17.955,11.139a.682.682,0,0,0-.682.682v6.819H6.364V7.729h6.819a.682.682,0,1,0,0-1.364H6.023A1.024,1.024,0,0,0,5,7.388V18.98A1.024,1.024,0,0,0,6.023,20H17.615a1.024,1.024,0,0,0,1.023-1.023v-7.16a.682.682,0,0,0-.682-.682M19.8,5.882,19.121,5.2a.686.686,0,0,0-.968,0l-.781.782a.34.34,0,0,0,0,.482l1.167,1.167a.34.34,0,0,0,.482,0L19.8,6.85a.686.686,0,0,0,0-.968m-9.328,7,5.732-5.739a.34.34,0,0,1,.482,0l1.167,1.167a.34.34,0,0,1,0,.482l-5.739,5.732a1.135,1.135,0,0,1-.361.259l-2.264,1.1a.286.286,0,0,1-.382-.382l1.1-2.264a1.135,1.135,0,0,1,.259-.361",
  transform: "translate(-5 -5)"
});

function SvgCompose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.003,
    height: 15.003,
    viewBox: "0 0 15.003 15.003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompose);
export default ForwardRef;